import React from "react";

export default () => (
  <div className="ring activity-ring mx-auto color-style">
    <div className="wrap">
      <div className="circle"></div>
    </div>
    <div className="wrap">
      <div className="circle"></div>
    </div>
    <div className="wrap">
      <div className="circle"></div>
    </div>
    <div className="wrap">
      <div className="circle"></div>
    </div>
    <div className="wrap">
      <div className="circle"></div>
    </div>
  </div>
);
